import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { gatewayAPI } from '../lib/api';
import { AlertTriangle } from 'lucide-react';

/**
 * Warning banner shown when the creator has not configured any payment gateway.
 * Checkout forms are hidden on public landing pages until at least one gateway is enabled.
 * Props:
 *  - compact?: boolean - smaller padding for inline usage in lists
 *  - ctaLabel?: string - custom CTA label
 */
export default function NoGatewayBanner({ compact = false, ctaLabel = 'Connect a gateway' }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let alive = true;
    gatewayAPI.status()
      .then(res => { if (alive) setStatus(res.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!status || status.has_gateway) return null;

  return (
    <div
      className={`rounded-2xl flex items-start gap-3 ${compact ? 'p-3' : 'p-4'} mb-4`}
      style={{
        border: '1.5px solid #FF9A00',
        backgroundColor: '#FFF6E6',
      }}
      data-testid="no-gateway-banner"
    >
      <div
        className="flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center"
        style={{ backgroundColor: '#FF9A00' }}
      >
        <AlertTriangle className="h-4 w-4" style={{ color: '#195259' }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold" style={{ color: '#195259' }}>
          No payment gateway connected
        </p>
        <p className="text-xs mt-0.5" style={{ color: '#195259', opacity: 0.75 }}>
          You can still sell free products. To accept paid orders, connect at least one payment gateway.
        </p>
      </div>
      <Link
        to="/app/payment-settings"
        className="flex-shrink-0 text-xs font-bold px-3 py-2 rounded-lg whitespace-nowrap transition-colors"
        style={{ backgroundColor: '#FF9A00', color: '#195259' }}
        data-testid="no-gateway-cta"
      >
        {ctaLabel} →
      </Link>
    </div>
  );
}
